// API Base URL
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://115.79.34.170:8089/api';
// export const API_BASE_URL = 'http://localhost:5000/api';

// Auth endpoints
export const AUTH_API = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  LOGOUT: `${API_BASE_URL}/auth/logout`,
  REFRESH_TOKEN: `${API_BASE_URL}/auth/refresh-token`,
  CHANGE_PASSWORD: `${API_BASE_URL}/auth/change-password`,
};

// Industry endpoints
export const INDUSTRY_API = {
  LIST: `${API_BASE_URL}/industries`,
  DETAIL: (id) => `${API_BASE_URL}/industries/${id}`,
  CREATE: `${API_BASE_URL}/industries`,
  UPDATE: (id) => `${API_BASE_URL}/industries/${id}`,
  DELETE: (id) => `${API_BASE_URL}/industries/${id}`,
};

// Factory endpoints
export const FACTORY_API = {
  LIST: `${API_BASE_URL}/factories`,
  DETAIL: (id) => `${API_BASE_URL}/factories/${id}`,
  CREATE: `${API_BASE_URL}/factories`,
  UPDATE: (id) => `${API_BASE_URL}/factories/${id}`,
  DELETE: (id) => `${API_BASE_URL}/factories/${id}`,
};

// Tenant endpoints
export const TENANT_API = {
  LIST: `${API_BASE_URL}/tenants`,
  ALL: `${API_BASE_URL}/tenants/all`,
  DETAIL: (id) => `${API_BASE_URL}/tenants/${id}`,
  CREATE: `${API_BASE_URL}/tenants`,
  UPDATE: (id) => `${API_BASE_URL}/tenants/${id}`,
  DELETE: (id) => `${API_BASE_URL}/tenants/${id}`,
  GET_CONTRACTS: (id) => `${API_BASE_URL}/tenants/${id}/contracts`
};

// Contract endpoints
export const CONTRACT_API = {
  LIST: `${API_BASE_URL}/contracts`,
  DETAIL: (id) => `${API_BASE_URL}/contracts/${id}`,
  CREATE: `${API_BASE_URL}/contracts`,
  GET_ACTIVE_CONTRACTS: `${API_BASE_URL}/contracts/active`,
  UPDATE: (id) => `${API_BASE_URL}/contracts/${id}`,
  DELETE: (id) => `${API_BASE_URL}/contracts/${id}`,
  DELETE_FILE: (id) => `${API_BASE_URL}/contracts/file/${id}`,
};

export const DEPOSIT_API = {
  LIST: `${API_BASE_URL}/deposits`,
  CREATE: `${API_BASE_URL}/deposits`,
  UPDATE: (id) => `${API_BASE_URL}/deposits/${id}`,
  DELETE: (id) => `${API_BASE_URL}/deposits/${id}`,
  GET_BY_CONTRACT: (contractId) => `${API_BASE_URL}/deposits/contract/${contractId}`,
  PAYMENT_HISTORY: (contractId) => `${API_BASE_URL}/deposits/history/${contractId}`,
};

export const INVOICE_API = {
  ALL: `${API_BASE_URL}/invoices/all`,
  CREATE: `${API_BASE_URL}/invoices`,
  DETAIL: (id) => `${API_BASE_URL}/invoices/${id}`,
  UPDATE: (id) => `${API_BASE_URL}/invoices/${id}`,
  DELETE: (id) => `${API_BASE_URL}/invoices/${id}`,
  PAY: (id) => `${API_BASE_URL}/invoices/${id}/pay`,
  PAYMENTS: (id) => `${API_BASE_URL}/invoices/${id}/payments`,
  SEND_REMINDER: `${API_BASE_URL}/invoices/action/reminder`,
  OVERDUE: `${API_BASE_URL}/invoices/action/overdue`,
  CONTRACT_PAYMENT_HISTORY: (contractId) => `${API_BASE_URL}/invoices/contract/${contractId}/payments`,
  EXPORT: `${API_BASE_URL}/invoices/export`,
  IMPORT: `${API_BASE_URL}/invoices/import`,
  TEMPLATE: `${API_BASE_URL}/invoices/template`
};

// System Activity logs endpoints
export const ACTIVITY_API = {
  LOGS: `${API_BASE_URL}/activity/logs`
}

export const UTILITY_API = {
  LIST: `${API_BASE_URL}/utilities`,
  CATEGORY_CREATE: `${API_BASE_URL}/utilities/categories`,
  CATEGORY_UPDATE: (id) => `${API_BASE_URL}/utilities/categories/${id}`,
  CATEGORY_DELETE: (id) => `${API_BASE_URL}/utilities/categories/${id}`,
  PLACE_CREATE: `${API_BASE_URL}/utilities/places`,
  PLACE_UPDATE: (id) => `${API_BASE_URL}/utilities/places/${id}`,
  PLACE_DELETE: (id) => `${API_BASE_URL}/utilities/places/${id}`,
};

export const SERVICE_API = {
  LIST: `${API_BASE_URL}/services`,
  CREATE: `${API_BASE_URL}/services`,
  UPDATE: (id) => `${API_BASE_URL}/services/${id}`,
  DELETE: (id) => `${API_BASE_URL}/services/${id}`,
};

// Electricity billing endpoints
export const ELECTRICITY_API = {
  LIST: `${API_BASE_URL}/electricity-bills`,
  CREATE: `${API_BASE_URL}/electricity-bills`,
  UPDATE: (id) => `${API_BASE_URL}/electricity-bills/${id}`,
  DELETE: (id) => `${API_BASE_URL}/electricity-bills/${id}`,
  GET_BY_ID: (id) => `${API_BASE_URL}/electricity-bills/${id}`,
  DOWNLOAD_TEMPLATE: `${API_BASE_URL}/electricity-bills/download/template`,
  IMPORT_BILLS: `${API_BASE_URL}/electricity-bills/import/template`
}

// Water billing endpoints
export const WATER_API = {
  LIST: `${API_BASE_URL}/water-bills`,
  DETAIL: (id) => `${API_BASE_URL}/water-bills/${id}`,
  WASTE_WATER: `${API_BASE_URL}/water-bills/waste-water`,
  WASTE_WATER_DELETE: (id) => `${API_BASE_URL}/water-bills/waste-water/${id}`,
  WASTE_WATER_UPDATE_STATUS: (id) => `${API_BASE_URL}/water-bills/waste-water/${id}/status`,
  WASTE_WATER_DETAIL: (id) => `${API_BASE_URL}/water-bills/waste-water/${id}`,
  CREATE: `${API_BASE_URL}/water-bills/create`,
  UPDATE: (id) => `${API_BASE_URL}/water-bills/${id}`,
  DELETE: (id) => `${API_BASE_URL}/water-bills/${id}`,
  DOWNLOAD_TEMPLATE: `${API_BASE_URL}/water-bills/download/template`,
  IMPORT_BILLS: `${API_BASE_URL}/water-bills/import/template`
};

// Report endpoints
export const REPORT_API = {
  DASHBOARD: `${API_BASE_URL}/reports/dashboard`,
  REVENUE: `${API_BASE_URL}/reports/revenue`,
  CONTRACTS: `${API_BASE_URL}/reports/contracts`,
  FACTORIES: `${API_BASE_URL}/reports/factories`,
  UTILITIES: `${API_BASE_URL}/reports/utilities`,
  TENANT_REPORT: `${API_BASE_URL}/reports/tenants`,
  GENERAL_REPORT: `${API_BASE_URL}/reports/general`,
  REVENUE_COMPARISON: `${API_BASE_URL}/reports/revenue-comparison`,
  FACTORY_GROUP: `${API_BASE_URL}/reports/factory-group`,
  YEARS: `${API_BASE_URL}/reports/years`,
  EXPORT_EXCEL: `${API_BASE_URL}/reports/export-excel`,
};

// Support/Feedback endpoints
export const SUPPORT_API = {
  LIST: `${API_BASE_URL}/feedback/admin/all`,
  DETAIL: `${API_BASE_URL}/feedback/user`,
  UPDATE: (id) => `${API_BASE_URL}/feedback/admin/${id}`,
  MESSAGES: {
    LIST: `${API_BASE_URL}/message/supports`,
    CREATE: (id) => `${API_BASE_URL}/message/supports/${id}/feedback`,
    UNREAD: `${API_BASE_URL}/message/unread`
  }
};

export const DIEUCHINHGIA_API = {
  DETAIL: (id) => `${API_BASE_URL}/priceAdjustment/contracts/${id}/price-adjustments`,
  UPDATE: (id) => `${API_BASE_URL}/priceAdjustment/contracts/${id}/price-adjustments`,
};

export const NOTIFICATION_API = {
  LIST: `${API_BASE_URL}/notifications/custom`,
  CREATE: `${API_BASE_URL}/notifications/custom`,
  READ: (id) => `${API_BASE_URL}/notifications/custom/${id}/read`,
  DELETE: (id) => `${API_BASE_URL}/notifications/custom/${id}`,
};

export const ADMIN_API = {
  LIST: `${API_BASE_URL}/users`,
  CREATE: `${API_BASE_URL}/users`,
  UPDATE: (id) => `${API_BASE_URL}/users/${id}`,
  DELETE: (id) => `${API_BASE_URL}/users/${id}`,
  DETAIL: (id) => `${API_BASE_URL}/users/${id}`,
};

export const USER_API = {
  ACTIVITY_LOGS: `${API_BASE_URL}/user-activities`,
};

export const RENT_API = {
  INVOICES: {
    LIST: `${API_BASE_URL}/invoices/all`,
    DETAIL: `${API_BASE_URL}/invoices/all`,
    CREATE: `${API_BASE_URL}/invoices/all`,
    UPDATE: (id) => `${API_BASE_URL}/invoices/${id}`,
    DELETE: (id) => `${API_BASE_URL}/invoices/${id}`,
  }
};

export const BANNER_API = {
  LIST: `${API_BASE_URL}/banners/admin`,
  CREATE: `${API_BASE_URL}/banners`,
  UPDATE: (id) => `${API_BASE_URL}/banners/${id}`,
  DELETE: (id) => `${API_BASE_URL}/banners/${id}`,
};

export const POPUP_API = {
  LIST: `${API_BASE_URL}/announcements/popup/admin`,
  CREATE: `${API_BASE_URL}/announcements/popup`,
  UPDATE: (id) => `${API_BASE_URL}/announcements/popup/${id}`,
  DELETE: (id) => `${API_BASE_URL}/announcements/popup/${id}`,
};
